import React, { Component } from "react"
import { withTranslation } from "react-i18next";
import './ConsentList.scss';

class ConsentList extends Component {  
  
    render() {
      const { t, consents,handleChange } = this.props;
      return (
        <fieldset>
        {consents.map((consent, i) => {
        return (
          <label key={i} className="checkbox-label">
            <input     
              className='checkbox'       
              type='checkbox' 
              value={i} 
              checked={consent.isChecked} 
              onKeyUp={e=> e.key === "Enter" ? handleChange(e) : null} 
              onChange={e=>handleChange(e)} />
              <span className="ps-2 pt-1">
                {t(`consentLabels#${consent.name}`)}                
              </span> 
            </label>        
        )})                
        }
        </fieldset>
      );
    }
  }
export default withTranslation()(ConsentList);